import "./App.css";
import React from "react";
import MainApp from "./components/main";
import "./styles/main.css";
import "antd/dist/antd.css";

const App = () => {
  return (
    <>
      <MainApp />
    </>
  );
};
export default App;
